<template>
  <div v-bind:class="{ 'dark-mode': darkTheme }">
    <transition name="slide-smooth">
      <div class="nav-side-menu h-100" v-bind:class="{ 'cursor-pointer': minimized, }">
        <vue-progress-bar></vue-progress-bar>
        <transition name="slide-smooth">
          <div class="top-container">
            <div class="no-drag item category-title2 mb-2 pb-1">
              <span class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row py-2">
                <router-link
                  to="/get-started"
                  tag="span"
                  class="css-ob4lje mx-2" style="width: 40px;height: 40px;background-size: cover;border-radius: 3px;"
                  :style="isMida ? 'background-image: url(&quot;https://uploads-ssl.webflow.com/64fddd2973684cc4d9ae26ac/65029e6be911682b42600980_mida-logo-192x192.png&quot;);' :
                  'background-image: url(&quot;https://uploads-ssl.webflow.com/62679692b1466017b8eae590/648b32b6ea6713e3cc7eddeb_howuku.webp&quot;);'"
                ></router-link>
                <div v-if="!minimized || showDuringMinimize" @click="showOption = !showOption" style="width: 80%;display: flex;justify-content: space-between;">
                  <span style="line-height: 1.5" >
                    <span class="font-weight-bold fs-12" 
                    style="color:#8e9caf!important; letter-spacing: -0.5px;font-family: 'Inter var', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';"
                    >{{ shorten(($session.get('company_name') || 'Projects').toUpperCase(),15) }}</span>
                    <br>
                    <b v-bind:key="refresher" class="my-auto">{{ widget_name }}</b>
                  </span>
                  <font-awesome-icon icon="chevron-down" class="fa-sm ml-auto my-auto mr-2"/>
                </div>
              </span>
            </div>   
<!-- <span @click="setProject(null, ''); projectChanged()">aaaaaa</span> -->
            <transition name="fade">
              <div
                class="dropdown-list dropdown-content-widget dropdown-menu-left scroll-list"
                v-on-clickaway="hideContent"
                v-if="showOption"
                style="max-height: 387px; overflow: hidden; overflow-y: scroll;margin-top: 16px;"
              >
                <span id="searchproject" class="p-0">
                  <input
                    class="search search-icon"
                    @keyup="filterName($event.target.value)"
                    :placeholder="t('Search projects')"
                  />
                </span>

                <div
                  v-for="item in projects"
                  v-bind:key="item.widget_id"
                  v-show="item.status === 1 || $session.get('company_id') === 1334"
                >
                  <div
                    v-if="
                      filterText === '' ||
                      item.widget_name
                        .toLowerCase()
                        .includes(filterText ? filterText.toLowerCase() : '')
                    "
                  >
                    <span @click="setProject(item.widget_id, item.widget_name, item.widget_key); projectChanged()">{{
                      item.widget_name
                    }}</span>
                  </div>
                </div>
                <router-link
                  @click="showSettingOption = false"
                  tag="span"
                  to="/website"
                  id="viewproject"
                >
                  {{ t('View All Projects') }}
                </router-link>
              </div>
            </transition>          

            <!-- <div
              v-if="$isOptimize"
              class="no-drag item category-title2"
              :class="{ activebg: $route.name == 'Optimize Overview' }"
            >
              <router-link
                to="/get-started"
                tag="span"
                class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row" style="height: 44px !important;line-height:1.75!important;"
              >
                <font-awesome-icon class="fa-lg mx-3 my-auto" icon="home" />
                <template v-if="!minimized || showDuringMinimize">
                  {{ t('Get Started') }}
                </template>
              </router-link>
            </div>                   -->

            <div
              @click.native="trackCategory('dashboard')"
              class="no-drag item category-title2"
              :class="{ activebg: $route.name.includes('Overview') }"
            >
              <router-link
                to="/get-started"
                tag="span"
                class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row" style="height: 44px !important;line-height:1.75!important;"
              >
                <font-awesome-icon class="fa-lg mx-3 my-auto" icon="home" />
                <template v-if="!minimized || showDuringMinimize">
                  {{ t('Dashboard') }}
                </template>
              </router-link>
            </div>     

            <div
              @click.native="trackCategory('experiment')"
              class="no-drag item category-title2"
              :class="{ activebg: $route.name.includes('Experiment') }"
            >
              <router-link
                to="/experiment"
                tag="span"
                class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row" style="height: 44px !important;line-height:1.75!important;"
              >
                <font-awesome-icon class="fa-lg mx-3 my-auto" icon="flask" />
                <template v-if="!minimized || showDuringMinimize">
                  {{ t('Experiments') }}
                </template>
              </router-link>
            </div>          
            
            <div
              @click.native="trackCategory('feature')"
              class="no-drag item category-title2"
              :class="{ activebg: $route.name.includes('Feature') }"
              v-if="$isMida"
            >
              <router-link
                to="/feature-flag"
                tag="span"
                class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row" style="height: 44px !important;line-height:1.75!important;"
              >
                <font-awesome-icon class="fa-lg mx-3 my-auto" icon="flag" />
                <template v-if="!minimized || showDuringMinimize">
                  {{ t('Feature Flags') }}
                </template>
              </router-link>
            </div>
            
            <!-- <div
              v-if="$isOptimize"
              @click.native="trackCategory('autopilot')"
              class="no-drag item category-title2"
              :class="{ activebg: $route.name == 'Autopilot' }"
            >
              <router-link
                to="/autopilot"
                tag="span"
                class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row" style="height: 44px !important;line-height:1.75!important;"
              >
                <font-awesome-icon class="fa-lg mx-3 my-auto" icon="rocket" />
                <template v-if="!minimized || showDuringMinimize">
                  {{ t('Autopilot AI') }}

                  <span class="badge badge-primary cursor-pointer ml-auto fs-10 my-auto">
                    BETA
                  </span>                  
                </template>
              </router-link>
            </div>                -->

            <div
              @click.native="trackCategory('goals')"
              class="no-drag item category-title2"
              :class="{ activebg: $route.name.includes('Goal') }"
            >
              <router-link
                to="/goals"
                tag="span"
                class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row" style="height: 44px !important;line-height:1.75!important;"
              >
                <font-awesome-icon class="fa-lg mx-3 my-auto" icon="bullseye" />
                <template v-if="!minimized || showDuringMinimize">
                  {{ t('Goals') }}
                </template>
              </router-link>
            </div>
            
            <!-- <div
              v-if="heatmapVal"
              class="no-drag item category-title2"
              :class="{ activebg: $route.name.includes('Heatmap') }"
            >
              <router-link
                @click.native="trackCategory('continuous_heatmap')"
                to="/heatmap/continuous"
                tag="span"
                class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row" style="height: 44px !important;line-height:1.75!important;"
              >
                <font-awesome-icon class="fa-lg mx-3 my-auto" icon="fire" />
                <template v-if="!minimized || showDuringMinimize">
                  {{ t('Heatmaps') }}
                </template>
              </router-link>
            </div>          -->

            
            <div v-if="!$isOptimize || [20, 21, 22, 23, 24].includes(Number($session.get('paid_plan')))" class="no-drag item category-title2" :class="{ activebg: $route.name == 'Polls' || $route.name === 'ViewPolls' }">
              <div
                v-if="$isOptimize && ($session.get('paid_plan') === 300)"
                class="nav-link btn-noshadow side-button d-flex flex-row" style="height: 44px !important;line-height:1.75!important;"
              >
                <svg class="fa-lg mx-3 my-auto" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0,0,256,256"><g fill="currentColor" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.12,5.12)"><path d="M25,0c-1.84766,0 -3.35937,1.28906 -3.8125,3h-12.1875c-1.65234,0 -3,1.34766 -3,3v39c0,1.65234 1.34766,3 3,3h32c1.65234,0 3,-1.34766 3,-3v-39c0,-1.65234 -1.34766,-3 -3,-3h-7.9375c-0.01953,0 -0.04297,0 -0.0625,0h-4.1875c-0.45312,-1.71094 -1.96484,-3 -3.8125,-3zM25,2c1.11719,0 2,0.88281 2,2c0,0.55078 0.44922,1 1,1h4v3h-14v-3h4c0.55078,0 1,-0.44922 1,-1c0,-1.11719 0.88281,-2 2,-2zM29,17c0.25391,0 0.52344,0.08594 0.71875,0.28125l2.28125,2.3125l2.28125,-2.3125c0.39063,-0.39062 1.04688,-0.39062 1.4375,0c0.39063,0.39063 0.39063,1.04688 0,1.4375l-2.3125,2.28125l2.3125,2.28125c0.39063,0.39063 0.39063,1.04688 0,1.4375c-0.19531,0.19531 -0.46094,0.28125 -0.71875,0.28125c-0.25781,0 -0.52344,-0.08594 -0.71875,-0.28125l-2.28125,-2.3125l-2.28125,2.3125c-0.19531,0.19531 -0.46094,0.28125 -0.71875,0.28125c-0.25781,0 -0.52344,-0.08594 -0.71875,-0.28125c-0.39062,-0.39062 -0.39062,-1.04687 0,-1.4375l2.3125,-2.28125l-2.3125,-2.28125c-0.39062,-0.39062 -0.39062,-1.04687 0,-1.4375c0.19531,-0.19531 0.46484,-0.28125 0.71875,-0.28125zM14,20h10c0.55469,0 1,0.44922 1,1c0,0.55078 -0.44531,1 -1,1h-10c-0.55469,0 -1,-0.44922 -1,-1c0,-0.55078 0.44531,-1 1,-1zM29,30c0.25391,0 0.52344,0.08594 0.71875,0.28125l2.28125,2.3125l2.28125,-2.3125c0.39063,-0.39062 1.04688,-0.39062 1.4375,0c0.39063,0.39063 0.39063,1.04688 0,1.4375l-2.3125,2.28125l2.3125,2.28125c0.39063,0.39063 0.39063,1.04688 0,1.4375c-0.19531,0.19531 -0.46094,0.28125 -0.71875,0.28125c-0.25781,0 -0.52344,-0.08594 -0.71875,-0.28125l-2.28125,-2.3125l-2.28125,2.3125c-0.19531,0.19531 -0.46094,0.28125 -0.71875,0.28125c-0.25781,0 -0.52344,-0.08594 -0.71875,-0.28125c-0.39062,-0.39062 -0.39062,-1.04687 0,-1.4375l2.3125,-2.28125l-2.3125,-2.28125c-0.39062,-0.39062 -0.39062,-1.04687 0,-1.4375c0.19531,-0.19531 0.46484,-0.28125 0.71875,-0.28125zM14,33h10c0.55469,0 1,0.44922 1,1c0,0.55078 -0.44531,1 -1,1h-10c-0.55469,0 -1,-0.44922 -1,-1c0,-0.55078 0.44531,-1 1,-1z"></path></g></g></svg>
                <div v-if="!minimized || showDuringMinimize">
                  {{ t('Survey') }}
                  <span
                  v-if="!minimized || showDuringMinimize"
                  class="badge badge-highlight cursor-pointer ml-auto fs-10 my-auto"
                  @click="upgradePlan"
                  >
                    Upgrade
                  </span>
                </div>
              </div>
              <router-link
                v-else
                @click.native="trackCategory('survey')"
                to="/survey"
                tag="span"
                class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row" style="height: 44px !important;line-height:1.75!important;"
              >
                <!-- <font-awesome-icon class="fa-lg mx-3 my-auto" icon="comment" /> -->
                <svg class="fa-lg mx-3 my-auto" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0,0,256,256"><g fill="currentColor" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.12,5.12)"><path d="M25,0c-1.84766,0 -3.35937,1.28906 -3.8125,3h-12.1875c-1.65234,0 -3,1.34766 -3,3v39c0,1.65234 1.34766,3 3,3h32c1.65234,0 3,-1.34766 3,-3v-39c0,-1.65234 -1.34766,-3 -3,-3h-7.9375c-0.01953,0 -0.04297,0 -0.0625,0h-4.1875c-0.45312,-1.71094 -1.96484,-3 -3.8125,-3zM25,2c1.11719,0 2,0.88281 2,2c0,0.55078 0.44922,1 1,1h4v3h-14v-3h4c0.55078,0 1,-0.44922 1,-1c0,-1.11719 0.88281,-2 2,-2zM29,17c0.25391,0 0.52344,0.08594 0.71875,0.28125l2.28125,2.3125l2.28125,-2.3125c0.39063,-0.39062 1.04688,-0.39062 1.4375,0c0.39063,0.39063 0.39063,1.04688 0,1.4375l-2.3125,2.28125l2.3125,2.28125c0.39063,0.39063 0.39063,1.04688 0,1.4375c-0.19531,0.19531 -0.46094,0.28125 -0.71875,0.28125c-0.25781,0 -0.52344,-0.08594 -0.71875,-0.28125l-2.28125,-2.3125l-2.28125,2.3125c-0.19531,0.19531 -0.46094,0.28125 -0.71875,0.28125c-0.25781,0 -0.52344,-0.08594 -0.71875,-0.28125c-0.39062,-0.39062 -0.39062,-1.04687 0,-1.4375l2.3125,-2.28125l-2.3125,-2.28125c-0.39062,-0.39062 -0.39062,-1.04687 0,-1.4375c0.19531,-0.19531 0.46484,-0.28125 0.71875,-0.28125zM14,20h10c0.55469,0 1,0.44922 1,1c0,0.55078 -0.44531,1 -1,1h-10c-0.55469,0 -1,-0.44922 -1,-1c0,-0.55078 0.44531,-1 1,-1zM29,30c0.25391,0 0.52344,0.08594 0.71875,0.28125l2.28125,2.3125l2.28125,-2.3125c0.39063,-0.39062 1.04688,-0.39062 1.4375,0c0.39063,0.39063 0.39063,1.04688 0,1.4375l-2.3125,2.28125l2.3125,2.28125c0.39063,0.39063 0.39063,1.04688 0,1.4375c-0.19531,0.19531 -0.46094,0.28125 -0.71875,0.28125c-0.25781,0 -0.52344,-0.08594 -0.71875,-0.28125l-2.28125,-2.3125l-2.28125,2.3125c-0.19531,0.19531 -0.46094,0.28125 -0.71875,0.28125c-0.25781,0 -0.52344,-0.08594 -0.71875,-0.28125c-0.39062,-0.39062 -0.39062,-1.04687 0,-1.4375l2.3125,-2.28125l-2.3125,-2.28125c-0.39062,-0.39062 -0.39062,-1.04687 0,-1.4375c0.19531,-0.19531 0.46484,-0.28125 0.71875,-0.28125zM14,33h10c0.55469,0 1,0.44922 1,1c0,0.55078 -0.44531,1 -1,1h-10c-0.55469,0 -1,-0.44922 -1,-1c0,-0.55078 0.44531,-1 1,-1z"></path></g></g></svg>
                <template v-if="!minimized || showDuringMinimize">
                  {{ t('Survey') }}
                </template>
              </router-link>
            </div>   
            
            <!-- <div class="no-drag item category-title2">
              <router-link
                to="/heatmap/split"
                tag="span"
                class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row" style="height: 44px !important;line-height:1.75!important;"
              >
                <svg class="fa-lg mx-3 my-auto" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0,0,256,256"><g fill="currentColor" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(8.53333,8.53333)"><path d="M15,0c-0.91667,0 -1.73144,0.37976 -2.24805,0.96094c-0.51661,0.58118 -0.75195,1.31684 -0.75195,2.03906h-2h-2c-1.64497,0 -3,1.35503 -3,3v18c0,1.64497 1.35503,3 3,3h14c1.64497,0 3,-1.35503 3,-3v-18c0,-1.64497 -1.35503,-3 -3,-3h-2h-2c0,-0.72222 -0.23535,-1.45788 -0.75195,-2.03906c-0.51661,-0.58118 -1.33138,-0.96094 -2.24805,-0.96094zM15,2c0.41667,0 0.60189,0.12024 0.75195,0.28906c0.15006,0.16882 0.24805,0.43316 0.24805,0.71094c0,0.27778 -0.09799,0.54212 -0.24805,0.71094c-0.15006,0.16882 -0.33529,0.28906 -0.75195,0.28906c-0.41667,0 -0.60189,-0.12024 -0.75195,-0.28906c-0.15006,-0.16882 -0.24805,-0.43316 -0.24805,-0.71094c0,-0.27778 0.09799,-0.54212 0.24805,-0.71094c0.15006,-0.16882 0.33529,-0.28906 0.75195,-0.28906zM8,5h2c0,1.105 0.895,2 2,2h6c1.105,0 2,-0.895 2,-2h2c0.56503,0 1,0.43497 1,1v18c0,0.56503 -0.43497,1 -1,1h-14c-0.56503,0 -1,-0.43497 -1,-1v-18c0,-0.56503 0.43497,-1 1,-1zM11,11.5c-0.82843,0 -1.5,0.67157 -1.5,1.5c0,0.82843 0.67157,1.5 1.5,1.5c0.82843,0 1.5,-0.67157 1.5,-1.5c0,-0.82843 -0.67157,-1.5 -1.5,-1.5zM15,12c-0.36064,-0.0051 -0.69608,0.18438 -0.87789,0.49587c-0.18181,0.3115 -0.18181,0.69676 0,1.00825c0.18181,0.3115 0.51725,0.50097 0.87789,0.49587h4c0.36064,0.0051 0.69608,-0.18438 0.87789,-0.49587c0.18181,-0.3115 0.18181,-0.69676 0,-1.00825c-0.18181,-0.3115 -0.51725,-0.50097 -0.87789,-0.49587zM11,18c-0.55228,0 -1,0.44772 -1,1c0,0.55228 0.44772,1 1,1c0.55228,0 1,-0.44772 1,-1c0,-0.55228 -0.44772,-1 -1,-1zM15,18c-0.36064,-0.0051 -0.69608,0.18438 -0.87789,0.49587c-0.18181,0.3115 -0.18181,0.69676 0,1.00825c0.18181,0.3115 0.51725,0.50097 0.87789,0.49587h4c0.36064,0.0051 0.69608,-0.18438 0.87789,-0.49587c0.18181,-0.3115 0.18181,-0.69676 0,-1.00825c-0.18181,-0.3115 -0.51725,-0.50097 -0.87789,-0.49587z"></path></g></g></svg>
                <template v-if="!minimized || showDuringMinimize">
                  {{ t('Heatmap') }}
                </template>
              </router-link>
            </div>             
             -->
            <div
              class="no-drag item category-title2"
              :class="{ activebg: $route.name == 'Events' }"
            >
              <router-link
                @click.native="trackCategory('events')"
                to="/events"
                tag="span"
                class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row" style="height: 44px !important;line-height:1.75!important;"
              >
                <svg class="fa-md mx-3 my-auto" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0,0,256,256"><g fill="currentColor" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(10.24,10.24)"><path d="M9.7,11.3l2.4,11.1c0.1,0.5 0.6,0.9 1.1,1c0.5,0.1 1.1,-0.2 1.4,-0.7l1.4,-2.6l3.9,3.9c0.5,0.5 1.4,0.5 1.9,0l2.4,-2.4c0.5,-0.5 0.5,-1.4 0,-1.9l-4,-3.7l2.5,-1.4c0.5,-0.3 0.8,-0.8 0.7,-1.4c-0.1,-0.6 -0.5,-1 -1,-1.1l-11.1,-2.3c-0.9,-0.2 -1.8,0.7 -1.6,1.5zM11,5.6c0.6,0 1,-0.5 1,-1v-3c0,-0.6 -0.5,-1 -1,-1c-0.6,0 -1,0.5 -1,1v3c0,0.5 0.4,1 1,1zM7.3,5.7l-2.2,-2.1c-0.4,-0.5 -1.1,-0.5 -1.5,0c-0.4,0.4 -0.4,1 0,1.4l2.1,2.1c0.4,0.4 1.1,0.4 1.5,0c0.5,-0.3 0.5,-1 0.1,-1.4zM0.6,10.9c0,0.6 0.5,1 1,1h3c0.6,0 1,-0.5 1,-1c0,-0.5 -0.5,-1 -1,-1h-3c-0.6,0 -1,0.5 -1,1zM5.8,14.7l-2.1,2.1c-0.4,0.4 -0.4,1.1 0,1.5c0.4,0.4 1.1,0.4 1.5,0l2.1,-2.1c0.4,-0.4 0.4,-1.1 0,-1.5c-0.5,-0.4 -1.1,-0.4 -1.5,0zM16.3,7.2l2.1,-2.2c0.4,-0.4 0.4,-1.1 0,-1.5c-0.4,-0.4 -1.1,-0.4 -1.5,0l-2.1,2.1c-0.4,0.4 -0.4,1.1 0,1.5c0.4,0.5 1.1,0.5 1.5,0.1z"></path></g></g></svg>
                <template v-if="!minimized || showDuringMinimize">
                  {{ t('Events') }}
                </template>
              </router-link>
            </div>   

            <!-- <div
              v-if="funnelVal"
              @click.native="trackCategory('funnel')"
              class="no-drag item category-title2"
              :class="{ activebg: $route.name == 'Funnel' }"
            >
              <router-link
                to="/funnel"
                tag="span"
                class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row" style="height: 44px !important;line-height:1.75!important;"
              >
                <font-awesome-icon class="fa-lg mx-3 my-auto" icon="filter" />
                <template v-if="!minimized || showDuringMinimize">
                  {{ t('Funnel') }}
                </template>
              </router-link>
            </div>             -->
            
            <!-- <div class="no-drag item category-title2" :class="{ activebg: $route.name.includes('Form') }">
              <router-link @click.native="trackCategory('form')" to="/form" tag="span" class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row" style="height: 44px !important;line-height:1.75!important;">
                <font-awesome-icon class="fa-lg mx-3 my-auto" icon="table" />
                <template v-if="!minimized || showDuringMinimize">
                  {{ t('Form Analytics') }}
                </template>
              </router-link>
            </div>                -->

            <div @click.native="trackCategory('deploy')" class="no-drag item category-title2" :class="{ activebg: ($route.name.includes('Deploy')||($route.name.includes('Targeting') && $route.params.from === 'deploy')) }">
              <!-- <div
                v-if="($session.get('paid_plan') === 20 || $session.get('paid_plan') === 300 || $session.get('paid_plan') === 301)"
                class="nav-link btn-noshadow side-button d-flex flex-row" style="height: 44px !important;line-height:1.75!important;"
              >
                <svg class="fa-lg mx-3 my-auto" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0,0,256,256"><g fill="#a7adba" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(4,4)"><path d="M20,6c-2.25,0 -3,1 -3,1v1h-7v8h7v12h6v-12h9v-3l-5,-5h-4v-1c0,0 -0.75,-1 -3,-1zM41,6c-3.449,1.112 -5,5.274 -5,9c0,2.64055 2.49711,4.60583 4.72266,5.77539l-0.72266,7.22461h8l-0.72266,-7.22461c2.22554,-1.16956 4.72266,-3.13484 4.72266,-5.77539c0,-3.726 -1.551,-7.888 -5,-9v8c0,0 -1,1 -3,1c-2,0 -3,-1 -3,-1zM6,25v5v4v24h52v-24v-4v-5h-4v5h-44v-5zM54,42v4h-44v-3z"></path></g></g></svg>
                <template v-if="!minimized || showDuringMinimize">
                  {{ t('Deploy') }}
                  <span
                    v-if="!minimized || showDuringMinimize"
                    class="badge badge-highlight cursor-pointer ml-auto fs-10 my-auto"
                    @click="upgradePlan"
                  >
                    Upgrade
                  </span>
                </template>
              </div> -->
              <router-link
                to="/deploy"
                tag="span"
                class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row" style="height: 44px !important;line-height:1.75!important;"
              >
                <!-- <svg class="fa-lg mx-3 my-auto"  version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0,0,256,256"><g fill="currentColor" fill-rule="nonzero" stroke="none" stroke-width="none" stroke-linecap="butt" stroke-linejoin="none" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path transform="scale(5.12,5.12)" d="M25.71875,1.28125l8,8c0.39844,0.39844 0.39844,1.03906 0,1.4375c-0.39844,0.39844 -1.03906,0.39844 -1.4375,0l-6.28125,-6.28125v27.5625c0.00391,0.35938 -0.18359,0.69531 -0.49609,0.87891c-0.3125,0.17969 -0.69531,0.17969 -1.00781,0c-0.3125,-0.18359 -0.5,-0.51953 -0.49609,-0.87891v-27.5625l-6.28125,6.28125c-0.39844,0.39844 -1.03906,0.39844 -1.4375,0c-0.39844,-0.39844 -0.39844,-1.03906 0,-1.4375l8,-8l0.71875,-0.6875zM17,16c0.35938,-0.00391 0.69531,0.18359 0.87891,0.49609c0.17969,0.3125 0.17969,0.69531 0,1.00781c-0.18359,0.3125 -0.51953,0.5 -0.87891,0.49609h-8v30h32v-30h-8c-0.35937,0.00391 -0.69531,-0.18359 -0.87891,-0.49609c-0.17969,-0.3125 -0.17969,-0.69531 0,-1.00781c0.18359,-0.3125 0.51953,-0.5 0.87891,-0.49609h10v34h-36v-34z" id="strokeMainSVG" stroke="currentColor" stroke-width="2" stroke-linejoin="round"></path><g transform="scale(5.12,5.12)" stroke="none" stroke-width="1" stroke-linejoin="miter"><path d="M25,0.59375l-0.71875,0.6875l-8,8c-0.39844,0.39844 -0.39844,1.03906 0,1.4375c0.39844,0.39844 1.03906,0.39844 1.4375,0l6.28125,-6.28125v27.5625c-0.00391,0.35938 0.18359,0.69531 0.49609,0.87891c0.3125,0.17969 0.69531,0.17969 1.00781,0c0.3125,-0.18359 0.5,-0.51953 0.49609,-0.87891v-27.5625l6.28125,6.28125c0.39844,0.39844 1.03906,0.39844 1.4375,0c0.39844,-0.39844 0.39844,-1.03906 0,-1.4375l-8,-8zM7,16v34h36v-34h-10c-0.35937,-0.00391 -0.69531,0.18359 -0.87891,0.49609c-0.17969,0.3125 -0.17969,0.69531 0,1.00781c0.18359,0.3125 0.51953,0.5 0.87891,0.49609h8v30h-32v-30h8c0.35938,0.00391 0.69531,-0.18359 0.87891,-0.49609c0.17969,-0.3125 0.17969,-0.69531 0,-1.00781c-0.18359,-0.3125 -0.51953,-0.5 -0.87891,-0.49609z"></path></g></g></svg> -->
                <svg class="fa-lg mx-3 my-auto" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0,0,256,256"><g fill="currentColor" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(4,4)"><path d="M20,6c-2.25,0 -3,1 -3,1v1h-7v8h7v12h6v-12h9v-3l-5,-5h-4v-1c0,0 -0.75,-1 -3,-1zM41,6c-3.449,1.112 -5,5.274 -5,9c0,2.64055 2.49711,4.60583 4.72266,5.77539l-0.72266,7.22461h8l-0.72266,-7.22461c2.22554,-1.16956 4.72266,-3.13484 4.72266,-5.77539c0,-3.726 -1.551,-7.888 -5,-9v8c0,0 -1,1 -3,1c-2,0 -3,-1 -3,-1zM6,25v5v4v24h52v-24v-4v-5h-4v5h-44v-5zM54,42v4h-44v-3z"></path></g></g></svg>
                <template v-if="!minimized || showDuringMinimize">
                  {{ t('Deploy') }}
                </template>
              </router-link>
            </div>

            <div @click.native="trackCategory('integration')" class="no-drag item category-title2" :class="{ activebg: ($route.name.includes('Integration')) }">
              <!-- <div
                v-if="($session.get('paid_plan') === 20 || $session.get('paid_plan') === 300 || $session.get('paid_plan') === 301)"
                class="nav-link btn-noshadow side-button d-flex flex-row" style="height: 44px !important;line-height:1.75!important;"
              >
                <font-awesome-icon class="fa-lg mx-3 my-auto" icon="plug" style="color: #a7adba !important" />
                <template v-if="!minimized || showDuringMinimize">
                  {{ t('Integration') }}
                  <span
                    v-if="!minimized || showDuringMinimize"
                    class="badge badge-highlight cursor-pointer ml-auto fs-10 my-auto"
                    @click="upgradePlan"
                  >
                    Upgrade
                  </span>
                </template>
              </div> -->
              <router-link
                
                to="/integration"
                tag="span"
                class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row" style="height: 44px !important;line-height:1.75!important;"
              >
                <!-- <svg class="fa-lg mx-3 my-auto"  version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0,0,256,256"><g fill="currentColor" fill-rule="nonzero" stroke="none" stroke-width="none" stroke-linecap="butt" stroke-linejoin="none" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path transform="scale(5.12,5.12)" d="M25.71875,1.28125l8,8c0.39844,0.39844 0.39844,1.03906 0,1.4375c-0.39844,0.39844 -1.03906,0.39844 -1.4375,0l-6.28125,-6.28125v27.5625c0.00391,0.35938 -0.18359,0.69531 -0.49609,0.87891c-0.3125,0.17969 -0.69531,0.17969 -1.00781,0c-0.3125,-0.18359 -0.5,-0.51953 -0.49609,-0.87891v-27.5625l-6.28125,6.28125c-0.39844,0.39844 -1.03906,0.39844 -1.4375,0c-0.39844,-0.39844 -0.39844,-1.03906 0,-1.4375l8,-8l0.71875,-0.6875zM17,16c0.35938,-0.00391 0.69531,0.18359 0.87891,0.49609c0.17969,0.3125 0.17969,0.69531 0,1.00781c-0.18359,0.3125 -0.51953,0.5 -0.87891,0.49609h-8v30h32v-30h-8c-0.35937,0.00391 -0.69531,-0.18359 -0.87891,-0.49609c-0.17969,-0.3125 -0.17969,-0.69531 0,-1.00781c0.18359,-0.3125 0.51953,-0.5 0.87891,-0.49609h10v34h-36v-34z" id="strokeMainSVG" stroke="currentColor" stroke-width="2" stroke-linejoin="round"></path><g transform="scale(5.12,5.12)" stroke="none" stroke-width="1" stroke-linejoin="miter"><path d="M25,0.59375l-0.71875,0.6875l-8,8c-0.39844,0.39844 -0.39844,1.03906 0,1.4375c0.39844,0.39844 1.03906,0.39844 1.4375,0l6.28125,-6.28125v27.5625c-0.00391,0.35938 0.18359,0.69531 0.49609,0.87891c0.3125,0.17969 0.69531,0.17969 1.00781,0c0.3125,-0.18359 0.5,-0.51953 0.49609,-0.87891v-27.5625l6.28125,6.28125c0.39844,0.39844 1.03906,0.39844 1.4375,0c0.39844,-0.39844 0.39844,-1.03906 0,-1.4375l-8,-8zM7,16v34h36v-34h-10c-0.35937,-0.00391 -0.69531,0.18359 -0.87891,0.49609c-0.17969,0.3125 -0.17969,0.69531 0,1.00781c0.18359,0.3125 0.51953,0.5 0.87891,0.49609h8v30h-32v-30h8c0.35938,0.00391 0.69531,-0.18359 0.87891,-0.49609c0.17969,-0.3125 0.17969,-0.69531 0,-1.00781c-0.18359,-0.3125 -0.51953,-0.5 -0.87891,-0.49609z"></path></g></g></svg> -->
                <font-awesome-icon class="fa-lg mx-3 my-auto" icon="plug" />
                <template v-if="!minimized || showDuringMinimize">
                  {{ t('Integration') }}
                </template>
              </router-link>
            </div>               
          </div>
        </transition>

        <template>
          <div
            class="btm-container w-100 p-3 position-fixed bg-white"
            style="left: 0px; max-width: calc(var(--sidebar-width) - 1px);bottom: 0px;"
          >
            <div class="pb-2 px-1" v-if="(!minimized || showDuringMinimize) && ($session.get('role') !== 3)">
              <span class="mr-2 small text-center">
                <div class="item text-left">
                  <div class="row" :key="monthly + 1">
                    <div class="col-md-5">
                      <p class="mb-1 pt-1 fs-12">
                        MTU
                        <span
                          class="tooltip-pop"
                          style="border-bottom: none;"
                          rel="Monthly Tested Users"
                        >
                          <font-awesome-icon
                            icon="info-circle"
                            class="fa fa-sm text-muted"
                          />
                        </span>
                      </p>
                    </div>
                    <div class="col-md-7 text-right">
                      <p class="mb-1 pt-1 fs-12">
                        {{ monthly ? monthly.toLocaleString() : 0 }}
                      </p>
                    </div>
                  </div>
                  <button
                    class="btn btn-block btn-cta my-2" @click="$router.push({ path: '/optimizecheckout' })">
                    <span><font-awesome-icon icon="arrow-up" class="fa fa-md mr-2"/>Upgrade Now</span>
                  </button>
                  <p class="mb-1 text-danger fs-14 font-weight-bold" v-if="$session.get('paid_plan') !== 300 && day2expire > 0 && day2expire < 1000 && day2expire > 0">
                    Trial expires in {{ day2expire }} days
                  </p>
                </div>
              </span>
            </div>
            <transition name="fade">
          <div
            class="dropdown-list dropdown-content-profile dropdown-menu-right"
            v-on-clickaway="hideContent"
            v-if="showSettingOption"
          >
            <router-link
              @click="showSettingOption = false"
              tag="span"
              to="/profile"
            >
              <font-awesome-icon class="mr-2 text-muted" icon="user-circle" />{{
                t('My Profile')
              }}
            </router-link>
            <template v-if="isAdminRole">
              <router-link
                @click="showSettingOption = false"
                tag="span"
                to="/company"
              >
                <font-awesome-icon class="mr-2 text-muted" icon="building" />{{
                  t('Company')
                }}
              </router-link>
              <router-link
                @click="showSettingOption = false"
                tag="span"
                to="/team"
              >
                <font-awesome-icon class="mr-2 text-muted" icon="users" />{{
                  t('Team')
                }}
              </router-link>
            </template>
            <template v-if="isAdminRole && ($session.get('paid_plan') === 104 || $session.get('company_id') === 1)">
              <span
                @click="toServicePortal"
              >
                <font-awesome-icon class="mr-2 text-muted" icon="star" />{{
                  t('Service Portal')
                }}
              </span>
            </template>

            <hr />

            <router-link
              @click="showSettingOption = false"
              tag="span"
              to="/website"
            >
              <font-awesome-icon class="mr-2 text-muted" icon="shapes" />{{
                t('Project')
              }}
            </router-link>
            <router-link
              @click="showSettingOption = false"
              tag="span"
              to="/block-ip"
            >
              <font-awesome-icon class="mr-2 text-muted" icon="ban" />{{
                t('Block IP')
              }}
            </router-link>
            <template v-if="isAdminRole">
              <hr />

              <router-link
                @click="showSettingOption = false"
                tag="span"
                to="/subscription"
              >
                <font-awesome-icon
                  class="mr-2 text-muted"
                  icon="money-bill"
                />{{ t('Subscription') }}
              </router-link>
              <router-link
                @click="showSettingOption = false"
                tag="span"
                to="/payment"
              >
                <font-awesome-icon class="mr-2 text-muted" icon="receipt" />{{
                  t('Payment')
                }}
              </router-link>
            </template>
            <hr />
            <router-link
              @click="showSettingOption = false"
              tag="span"
              to="/logout"
            >
              <font-awesome-icon
                class="mr-2 text-muted"
                icon="sign-out-alt"
              />{{ t('Logout') }}
            </router-link>
          </div>
        </transition>

            <div class="d-flex mt-3 px-1 cursor-pointer" @click="showSettingOption = !showSettingOption">
              <div class="my-auto">
                <span class="headerMenu text-decoration-none cursor-pointer mr-2 font-weight-bold">
                  <div class="d-inline-block">
                    <span class="font-weight-normal">
                      <img
                        class="d-inline mr-2 profile-picture perfect-circle my-auto mx-auto"
                        width="32"
                        height="32"
                        :src="`https://api.howuku.com/avatar/${$session.get('email')}?v=6&name=${$session.get('name')}`"
                        @error="handleImageError"
                      />
                    </span>
                  </div>
                </span>                
              </div>
              <div>
                <p class="font-weight-bolder mb-0">{{ shorten($session.get('name'),14) }}</p>
                <span v-if="[20, 21, 22, 23].includes($session.get('paid_plan'))" class="text-muted font-weight-light fs-12">
                  {{ roles[$session.get('role')] }}
                </span>
                <span v-else class="text-muted font-weight-light fs-12">
                  <template v-if="day2expire < 1000 && day2expire > 0">Trial</template>
                  <template v-if="day2expire > 1000">Lifetime</template>{{ setAgencyName(plan.plan_name) }} Plan  
                </span>
              </div>
              <div class="ml-auto my-auto">
                <font-awesome-icon icon="chevron-up" class="text-muted" />
              </div>
            </div>            
          </div>
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import { store } from '@/store'

/* eslint-disable */
export default {
  mixins: [clickaway],
  store,
  components: {},
  watch: {
    '$store.getters.widget_id': {
      handler: function () {
        this.loadData()
      },
      deep: true,
    },
    '$store.getters.notifFeedback': {
      handler: function (v) {
        this.notificationCount = v
      },
      deep: true,
    },
  },
  data: function () {
    return {
      isMida: true,
      showSettingOption: false,
      showOption: false,
      promoText: '',
      isEventPromo: false,
      darkTheme: false,
      isSession: false,
      hoverDelay: null,
      minimized: false,
      showDuringMinimize: false,
      availableUsersCounter: 1,
      notificationCount: 0,
      monthly: 0,
      feedbackVal: 0,
      surveyVal: 0,
      recordVal: 0,
      heatmapVal: 0,
      eventtrackVal: 0,
      formAnalyticVal: 0,
      abtestVal: 0,
      personalizeVal: 0,
      analyticsVal: 0,
      funnelVal: 0,
      errortrackVal: 0,
      recommendationsVal: 0,
      goalVal: 0,
      widgets: {},
      acl_data: {},
      pageviewLimit: 0,
      contentStatus: '',
      day2expire: null,
      plan: {},
      isHowuku: false,
      isAdmin:
        this.$session.get('role') === 0 || this.$session.get('role') === 1,
      enableRecommendVal: 0,
      totalUnreadRecomm: 0,
      isShopify: false,
      isAdminRole: false,
      refresher: 0,
      roles: {
        0: "Owner",
        1: "Admin",
        2: "User",
        3: "Viewer",
      }
    }
  },
  beforeCreate() {
    this.$http.get(process.env.API_ENDPOINT + '/plan/info/' + this.$session.get('paid_plan')).then((response) => {
      let data = response.data
      this.plan = data[this.$session.get('paid_plan')]
    })
    this.$http.get(process.env.API_ENDPOINT + '/trial').then((response) => {
      let data = response.data
      this.day2expire =
        data[0].days_to_expire > 0 ? data[0].days_to_expire : null
      this.$session.set('day2expire', this.day2expire)
    })
  },
  beforeMount() {
    this.isMida = window.location.href.includes('.mida.so/') || window.location.href.includes('//localhost')

    this.isAdminRole =
      this.$session.get('role') !== 3 && this.$session.get('role') !== 2

    // this.darkTheme = Number(this.$session.get('company_id')) % 2
    this.darkTheme = true
    if (window.location.host === 'sp.howuku.com') this.isShopify = true

    this.$http.get(process.env.API_ENDPOINT + '/users/active').then((response) => {
      let data = response.data
      this.availableUsersCounter = data.length
    })
    setTimeout(() => {
      this.$http
        .get(process.env.API_ENDPOINT + '/user/attribute/REASON_NO_UPGRADE')
        .then((result) => {})
        .catch((err) => {
          //SHOW
          if (this.day2expire < 6 && this.day2expire > 0)
            this.messages = [
              {
                key: 'REASON_NO_UPGRADE',
                subject: 'Your trial will end in ' + this.day2expire + ' days',
                body: "What's stopping you from upgrading your account today?",
                options: [
                  "I can't justify the price",
                  'Still evaluating',
                  'Need budget approval',
                ],
              },
            ]
        })
    }, 3000)
  },
  mounted() {
    this.$version = 2
    try {
      if (localStorage.getItem('projects')){ 
        this.projects = JSON.parse(localStorage.getItem('projects'))
        this.setupProject()
      }
    } catch(e) {}

    
    // if there is no widget
    let intChecking = setInterval(() => {
      if (this.$session.exists() && !Number(this.$session.get('widget_id'))) {
        if (this.projects) {
          let foundWidget = false
          for (let i = 0; i < this.projects.length; i++) {
            if (Number(this.projects[i].status) === 1) {
              clearInterval(intChecking)
              foundWidget = true
              let id = this.projects[i].widget_id
              let key = this.projects[i].widget_key
              this.widget_name = this.projects[i].widget_name
              this.setProject(id, this.widget_name, key)
              break
            }
          }  

          if (!foundWidget) {
            clearInterval(intChecking)
            this.$swal.fire({
              title: 'Error with empty project',
              text: "Please select a Project from the top left of the sidebar!",
              type: 'warning',
              confirmButtonColor: '#2167f5'
            })            
          }
        }      
      } else if (Number(this.$session.get('widget_id'))) {
        clearInterval(intChecking)
      }
    }, 1000)

    this.$http
    .post(process.env.API_ENDPOINT + '/getWidgetsNoCache', {
      user_id: this.$session.get('user_id'),
    })
    .then((response) => {
      this.projects = response.data
      this.setupProject()
      localStorage.setItem('projects', JSON.stringify(response.data))
    })    

    this.isLocalhost = window.location.host.includes('localhost')
    this.isHowuku =
      window.location.host === 'app.howuku.com' ||
      window.location.host.includes('localhost') ||
      window.location.host === 'demo.howuku.com'
    this.darkTheme = false // dark theme only for Howuku

    setTimeout(() => {
      // not sure why timeout is needed but without it would be getting 0 value
      this.loadData()
    }, 1000)
  },
  methods: { 
    toServicePortal() {
      this.showSettingOption = false
      window.open('/service-portal', '_blank');
    },    
    handleImageError(event) {
      // let curName = this.$session.get('name')
      // let convertedName = curName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "dj").replace(/Đ/g, "DJ");
      let img = event.target;
      let curEmail = this.$session.get('email')
      axios
        .get('https://api.howuku.com/avatar/' + curEmail + '?v=6&name=' + 'N', { responseType: 'blob' })
        .then(response => {
          const reader = new FileReader();
          reader.onload = () => {
            img.src = reader.result;
          };
          reader.readAsDataURL(response.data);
        })
        .catch(error => {
          console.log(error)
        })
    },    
    shorten(string, len) {
      if (!string) return string

      if (string.length > len) return string.substring(0, len) + '...'
      else return string
    },    
    hideContent() {
      this.showOption = false
      this.showHelpOption = false
      this.showSettingOption = false
      this.filterText = ''
    },
    setupProject() {
      // redirected from weekly winner email, switch to the widget in the email
      if (this.$route.params.widget_id && (this.$route.name === 'Optimize Overview' || this.$route.name === 'Experiment')) {
        for (let i = 0; i < this.projects.length; i++) {
          if (Number(this.projects[i].widget_id) === Number(this.$route.params.widget_id)) {
            let id = this.projects[i].widget_id
            let name = this.projects[i].widget_name
            let key = this.projects[i].widget_key
            this.setProject(id, name, key)
            break
          }
        }
      } else if (this.$session.exists()) {
        for (let i = 0; i < this.projects.length; i++) {
          if (this.$session.get('widget_id') === this.projects[i].widget_id && Number(this.projects[i].status) === 1) {
            let id = this.projects[i].widget_id
            this.widget_name = this.projects[i].widget_name
            let key = this.projects[i].widget_key
            this.setProject(id, this.widget_name, key)
            break
          }
        }
      } else if (localStorage.getItem('widget_name') && localStorage.getItem('widget_id') && localStorage.getItem('widget_key')) {
        this.setProject(localStorage.getItem('widget_id'), localStorage.getItem('widget_name'), localStorage.getItem('widget_key'))
      }     
    }, 
    projectChanged(){
      this.$auditlog({ module: 'usage', action: 'change_project' })  
            
      try{
        howuku.track('usage', { feature: 'change_project' })
      }catch(e){}

      try{
        _cio.track('usage', { feature: 'change_project', created_at: Math.round(new Date().getTime() / 1000) })
      }catch(e){}      
    },
    setProject(id, name, key) {
      this.filterText = ''
      localStorage.setItem('widget_name', name)
      localStorage.setItem('widget_id', id)
      localStorage.setItem('widget_key', key)
      this.showOption = false
      this.widget_name = name
      this.$session.set('widget_name', name)
      this.$session.set('widget_id', id)
      this.$session.set('widget_key', key)
      // this.$session.set('widget_id', id)
      this.$http.defaults.headers.widgetid = id
      this.$store.commit('setWidgetId', id)

      let dp = this.$store.getters.datepicker
      for (let i in dp) {
        let original = dp[i].startDate
        this.$store.commit('setDatepicker', {
          module: i,
          name: 'startDate',
          data: 1,
        })

        this.$store.commit('setDatepicker', {
          module: i,
          name: 'startDate',
          data: original,
        })
      }

      this.refresher++     
      this.$store.commit('setRefresher', +(new Date))

    },    
    async trackCategory(key) {
      try {
        this.$auditlog({
          module: 'category',
          action: key,
        })
      } catch (e) {}
      try {
        _cio.track('category', {
          name: key,
          created_at: Math.round(new Date().getTime() / 1000),
        })
      } catch (e) {
        console.error(e)
      }
    },
    toogleMinimize(bool) {
      setTimeout(() => {
        this.minimized = bool
        this.showDuringMinimize = false
        if (bool === true)
          document.body.style.setProperty('--sidebar-width', '60px')
        else document.body.style.setProperty('--sidebar-width', '260px')
      }, 10)
    },
    heatmapOldVersion() {
      return localStorage.getItem('heatmap_preference') === 'v1'
    },
    setAgencyName(n) {
      if (n === 'Premium' && this.$session.get('lifetimedeal')) return 'Agency'
      return n
    },
    numberToText2(n) {
      if (n === 0) return 0
      if (n >= 1000000) return parseInt(n / 1000000).toString() + 'M'
      if (n >= 1000) return parseInt(n / 1000).toString() + 'K'
      return n
    },
    numberToText(n) {
      if (n === 0) return ''
      if (n >= 1000000) return '/ ' + (n / 1000000).toString() + 'M'
      if (n >= 1000) return '/ ' + (n / 1000).toString() + 'K'
      return '/ ' + n
    },
    numberFormat(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    feature(data, value) {
      return data.includes(value)
    },
    loadData: function () {
      this.$http
        .get(process.env.API_ENDPOINT + '/mtu')
        .then((response) => {
          let data = response.data
          this.monthly = data.usage
        })

        // this.$http
        // .post(process.env.API_ENDPOINT + '/getWidgetsNoCache', {
        //   widget_id: this.$session.get('widget_id'),
        // })
        // .then((response) => {

    },
    cap100(n) {
      return n < 100 ? n : 100
    },
    logout: function () {
      this.$router.push({ path: '/logout' })
    },
    upgradePlan() {
      if (this.$session.get('paid_plan') === 20) {
        this.$swal.fire({
          title: 'Upgrade Account',
          text: "Your current plan not support this feature, update your plan to use this feature.",
          type: 'warning',
          confirmButtonColor: '#2167f5'
        })
      } else if (this.$session.get('paid_plan') === 300 || this.$session.get('paid_plan') === 301) {
        this.$swal.fire({
          title: 'Upgrade to Growth Plan',
          text: "You need to upgrade your account to Growth Plan and above to use this feature.",
          type: 'warning',
          confirmButtonColor: '#2167f5'
        })
      }
    }
  },
}
</script>
<style scoped="scoped">
.nav-link {
  font-size: 1rem !important;
}
.side-button {
  padding-left: initial !important;
  padding-right: initial !important;
  margin-bottom: 0.75rem !important;
}

.dropdown-content-widget

.dropdown-menu-left {
  left: 0px;
}

.dropdown-content-widget {
  margin-left: 0px;
}

.activebg span svg {
  /* background: red !important; */
  fill: rgb(29 41 57) !important;
  stroke: rgb(29 41 57) !important;
  color: rgb(29 41 57) !important;
}

.activebg span {
  font-weight: 700 !important;
}
</style>

<style>
/* Hide scrollbar for Chrome, Safari and Opera */

.slideDown-enter-active,
.slideDown-leave-active {
  transition: all 0.1s ease-out;
  overflow: hidden;
}
.slideDown-enter, .slideDown-leave-to /* .fade-leave-active below version 2.1.8 */ {
  height: 0;
}
.slideDown-enter-to,
.slideDown-leave {
  height: 50px;
}

.bottom-container {
  /* background-color: #f6f7f9; */
  /* background-color: rgba(var(--main-color), 0.04); */
  border-radius: 8px;
  padding: 0px 6px;
  box-shadow: 0 6px 6px 0 rgb(0 0 0 / 3%), 0 1px 2px 0 rgb(0 0 0 / 4%);
}

.show-enter-active,
.show-leave-enter {
  /* transform: translateX(0); */
  transition: width 1s linear;
}
.show-enter,
.show-leave-to {
  /* transform: translateX(100%); */
}
.dropdown-content-profile {
  position: absolute;
  background-color: var(--background);
  bottom: 70px;
  left: 10px;
  width: 300px;
  /* right: 20px !important; */
  max-width: 220px;
  -webkit-box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 2px 0;
  text-align: left;
  z-index: 10;
  border: 1px #ccc solid;
}

.dropdown-list > hr {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
}

.dropdown-list span {
  color: var(--color);
  padding: 12px 20px;
  text-decoration: none;
  display: block;
  cursor: default;
}

.dropdown-list span:hover {
  background-color: rgba(var(--main-color), 0.1);
}

.dropdown-content-widget {
  position: absolute;
  background-color: var(--background);
  top: 55px;
  margin-left: 30px;
  max-width: 500px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  text-align: left;
  z-index: 10;
  border: 1px #ccc solid;
}

.dropdown-content-project {
  position: absolute;
  background-color: var(--background);
  top: 55px;
  /* left: 30px !important; */
  right: 77px !important;
  max-width: 220px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 2px 0;
  text-align: left;
  z-index: 10;
  border: 1px #ccc solid;
}

.scroll-list::-webkit-scrollbar {
  display: none;
  position: sticky;
}
#viewproject {
  background: white;
  position: -webkit-sticky;
  position: sticky;
  bottom: 0px;
  border-top: 0.05px lightgrey solid;
  text-align: center;
}
#viewproject:hover {
  background-color: #e6eaee;
}
#searchproject {
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  border-bottom: 1px solid #e8e8e8;
}
#searchproject:hover {
  background-color: none;
}
#searchproject input.search {
  height: 44px;
  border: none !important;
  outline: 0px;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  font-weight: 500;
  width: 100%;
}
#searchproject input.search::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  padding-left: 3px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.5);
}
#searchproject input.search::-moz-placeholder {
  /* Firefox 19+ */
  padding-left: 3px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.5);
}
#searchproject input.search:-ms-input-placeholder {
  /* IE 10+ */
  padding-left: 3px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.5);
}
#searchproject input.search:-moz-placeholder {
  /* Firefox 18- */
  padding-left: 3px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/layouts/menus/SideMenuLite.vue